import { styled } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import React, { FunctionComponent, useState } from "react";
import { grey } from "designSystem/styles/color";
import CsiImage from "../image/CsiImage";
import Violation from "./violation.png";
import DefaultViolation from "./default-violation.png";

const PREFIX = "ColorChip";

const classes = {
	colorChip: `${PREFIX}colorChip`,
	chipBorder: `${PREFIX}chipBorder`,
	chipBorderDefault: `${PREFIX}chipBorderDefault`,
	hidden: `${PREFIX}hidden`,
	missingIcon: `${PREFIX}missingIcon`,
	violationPlaceholder: `${PREFIX}violationPlaceholder`,
};

const Root = styled("div")(({
	theme,
}) => ({
	height: 16,
	width: 16,

	alignItems: "center",
	borderRadius: 5,
	display: "flex",
	justifyContent: "center",
	overflow: "hidden",

	[`& .${classes.colorChip}`]: {
		height: 16,
		position: "absolute",
		width: 16,
	},
	[`& .${classes.chipBorder}`]: {
		height: 14,
		width: 14,
		border: "1px solid #000000",
		borderRadius: 5,
		opacity: "10%",
		position: "absolute",
	},
	[`& .${classes.chipBorderDefault}`]: {
		height: 14,
		width: 14,

		border: "1px dashed",
		borderColor: grey[700],
		borderRadius: 5,
	},
	[`& .${classes.hidden}`]: {
		display: "none !important",
	},
	[`& .${classes.missingIcon}`]: {
		// need to override IconButton sizing
		"&.MuiSvgIcon-root": {
			fontSize: 8,
		},
	},
	[`& .${classes.violationPlaceholder}`]: {
		height: 18,
		position: "absolute",
	},
}));

export interface ColorChipProps {
	/** indicate if this chip has violation or not */
	hasViolation?: boolean;

	/** indicates if this is the default color */
	isDefault?: boolean;

	/** source for color image */
	src?: string;
}

export const MissingIcon = () => {
	const { missingIcon } = classes;

	return (
		<SvgIcon className={missingIcon} viewBox="0 0 6 8">
			<path
				clipRule="evenodd"
				d="M0 2.66667C0 1.19333 1.19333 0 2.66667 0C4.14 0 5.33333 1.19333 5.33333 2.66667C5.33333 3.52195 4.80665 3.98221 4.29384 4.43036C3.80735 4.85551 3.33333 5.26975 3.33333 6H2C2 4.78582 2.62808 4.30439 3.1803 3.88112C3.61349 3.54907 4 3.25281 4 2.66667C4 1.93333 3.4 1.33333 2.66667 1.33333C1.93333 1.33333 1.33333 1.93333 1.33333 2.66667H0ZM3.33333 6.66667V8H2V6.66667H3.33333Z"
				fill="#D14030"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export const ColorChip: FunctionComponent<ColorChipProps> = (props) => {
	const {
		colorChip,
		chipBorder,
		chipBorderDefault,
		hidden,
		violationPlaceholder,
	} = classes;
	const { hasViolation, isDefault, src } = props;
	const [isError, setError] = useState(false);

	if (isDefault) {
		return (
			<Root>
				<CsiImage className={hasViolation ? violationPlaceholder : hidden} src={DefaultViolation} />
				<div className={hasViolation ? "" : chipBorderDefault} />
			</Root>
		);
	}

	return (
		<Root>
			<div className={chipBorder} />
			{isError || !src ?
				<MissingIcon />
				: (
					<img
						className={hasViolation ? colorChip : null}
						onError={() => setError(true)}
						src={src}
					/>
				)}
			<CsiImage className={hasViolation ? violationPlaceholder : hidden} src={Violation} />
		</Root>
	);
};

export default ColorChip;